export default __webpack_public_path__ + "static/media/polar.1d1f36ee.jpg";